import InfiniteScroll from 'react-infinite-scroll-component';
import {Beer} from 'typescript/models/Beer';

import BeersListItem from '../BeersListItem/BeersListItem';

import './BeersList.scss';

interface IBeersListProps {
  list: Beer[];
  getNextPage: (page: number) => void;
  page: number;
  hasMore: boolean;
}

const BeersList = ({list, page, hasMore, getNextPage}: IBeersListProps) => {
  return (
    <div className="beers-list" id="scrollable-div">
      <InfiniteScroll
        loader={<></>}
        dataLength={list.length}
        next={() => getNextPage(page)}
        hasMore={hasMore}
        style={{overflow: 'hidden'}}
        scrollableTarget="scrollable-div"
      >
        {list.map((beer) => (
          <BeersListItem key={beer.id} beer={beer} />
        ))}
      </InfiniteScroll>
    </div>
  );
};

export default BeersList;
